import React from 'react'
import PropTypes from 'prop-types'

const InstagramIcon = (props) => {
  const { claseses = 'w-20', color = '#ffffff' } = props
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={claseses}
    >
      <g clipPath="url(#clip0_3180_21434)">
        <path
          d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z"
          fill="url(#paint0_linear_3180_21434)"
        />
        <path
          d="M12.7037 3.9873H7.3158C6.88112 3.9873 6.45071 4.07292 6.04913 4.23926C5.64754 4.40561 5.28264 4.64942 4.97528 4.95678C4.66792 5.26414 4.4241 5.62903 4.25776 6.03062C4.09142 6.43221 4.0058 6.86263 4.0058 7.29731V12.6847C4.00594 13.5624 4.35474 14.4042 4.97547 15.0249C5.5962 15.6455 6.43802 15.9941 7.3158 15.9941H12.7037C13.1383 15.9942 13.5687 15.9087 13.9703 15.7424C14.3719 15.5761 14.7368 15.3323 15.0442 15.025C15.3516 14.7177 15.5954 14.3528 15.7617 13.9513C15.9281 13.5497 16.0137 13.1193 16.0137 12.6847V7.29731C16.0138 6.86261 15.9282 6.43216 15.7619 6.03054C15.5956 5.62892 15.3518 5.264 15.0444 4.95663C14.737 4.64925 14.3721 4.40544 13.9705 4.23912C13.5688 4.0728 13.1384 3.98724 12.7037 3.9873ZM15.0432 12.6715C15.0432 13.2956 14.7952 13.8941 14.3539 14.3355C13.9126 14.7768 13.3141 15.0247 12.69 15.0247H7.32948C6.70543 15.0245 6.10699 14.7766 5.66571 14.3353C5.22444 13.894 4.97646 13.2956 4.97632 12.6715V7.31046C4.97646 6.68641 5.22444 6.08795 5.66571 5.64668C6.10699 5.20541 6.70543 4.95744 7.32948 4.9573H12.6895C13.3136 4.9573 13.9121 5.20523 14.3534 5.64653C14.7947 6.08783 15.0426 6.68636 15.0426 7.31046L15.0432 12.6715Z"
          fill="white"
        />
        <path
          d="M10.0095 6.82617C9.38368 6.82617 8.77195 7.01174 8.25161 7.3594C7.73127 7.70707 7.3257 8.20122 7.08619 8.77937C6.84668 9.35752 6.78399 9.99371 6.90604 10.6075C7.02809 11.2213 7.3294 11.7851 7.77187 12.2276C8.21434 12.6702 8.77809 12.9716 9.39186 13.0937C10.0056 13.2159 10.6418 13.1533 11.22 12.9139C11.7982 12.6745 12.2924 12.269 12.6402 11.7487C12.9879 11.2284 13.1736 10.6167 13.1737 9.99091C13.1738 9.57533 13.092 9.16382 12.933 8.77986C12.774 8.3959 12.5409 8.04702 12.2471 7.75314C11.9533 7.45926 11.6044 7.22613 11.2205 7.06708C10.8366 6.90803 10.4251 6.82617 10.0095 6.82617ZM10.0095 12.0546C9.60135 12.0545 9.20242 11.9334 8.86311 11.7065C8.52381 11.4797 8.25939 11.1574 8.10328 10.7803C7.94716 10.4032 7.90637 9.98826 7.98606 9.58798C8.06574 9.1877 8.26232 8.82004 8.55095 8.53148C8.83958 8.24292 9.2073 8.04642 9.6076 7.96684C10.0079 7.88725 10.4228 7.92815 10.7999 8.08436C11.1769 8.24057 11.4992 8.50508 11.7259 8.84444C11.9527 9.1838 12.0737 9.58277 12.0737 9.99091C12.0737 10.262 12.0203 10.5304 11.9166 10.7808C11.8128 11.0312 11.6608 11.2587 11.4691 11.4503C11.2774 11.642 11.0498 11.794 10.7994 11.8977C10.549 12.0013 10.2805 12.0547 10.0095 12.0546Z"
          fill="white"
        />
        <path
          d="M13.2816 7.43172C13.6737 7.43172 13.9916 7.11384 13.9916 6.72172C13.9916 6.3296 13.6737 6.01172 13.2816 6.01172C12.8895 6.01172 12.5716 6.3296 12.5716 6.72172C12.5716 7.11384 12.8895 7.43172 13.2816 7.43172Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3180_21434"
          x1="20"
          y1="1.22"
          x2="2.54"
          y2="19.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B735B7" />
          <stop offset="1" stopColor="#EC9F5A" />
        </linearGradient>
        <clipPath id="clip0_3180_21434">
          <rect width="20" height="20" />
        </clipPath>
      </defs>
    </svg>
  )
}

InstagramIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(InstagramIcon)
